import { GetServerSideProps, NextPage } from 'next';
import React from 'react';

import { pagesConfigStore } from '~/atomic/atom/links/pagesConfigStore';
import { CommonLayout } from '~/atomic/layout/CommonLayout';
import { LayoutType } from '~/atomic/layout/DefaultLayout';
import { PageTemplate } from '~/atomic/organism/PageTemplate/PageTemplate';
import { Check } from '~/atomic/page/anti-pirate/check/Check';
import { checkAuthToken } from '~/feature/authorization/checkAuthToken';
import { createStore, RootState } from '~/store';

const AntiPirateCheckPage:NextPage & LayoutType = () => {
  const title = 'Проверить произведение | Произведения авторов полностью на Bookriver';
  const description = 'Проверить произведение — литературно-издательская площадка Bookriver'
  + ' ⭐ Серии книг ⭐ Полные циклы произведений'
  + ' ⭐ Комментарии и отзывы читателей ⭐ Скачать произведения'
  + ' полностью в формате fb2 ✉ Найдите интересную'
  + ' книгу на нашем сайте и читайте удобно онлайн';

  return (
    <PageTemplate
      isPublic={pagesConfigStore.antiPirateCheck.isPublic}
      seo={{
        title,
        description,
        canonical: pagesConfigStore.antiPirateCheck.url,
      }}
      content={(<Check />)}
    />
  );
};

AntiPirateCheckPage.getLayout = (page) => (
  <CommonLayout>{ page }</CommonLayout>
);

export const getServerSideProps: GetServerSideProps<{ state: RootState; }> = async (context) => {
  const { dispatch, store } = await createStore();
  const isLoggedIn = await checkAuthToken(context, dispatch);

  const state = store.getState();
  return { props: { state } };
};

export default AntiPirateCheckPage;
